export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      2848.798185941043,
    ],
    button_spin: [
      4000,
      544.2176870748297,
    ],
    free_bet_big_win: [
      6000,
      1377.2335600907031,
    ],
    free_bet_mega_win: [
      9000,
      2213.151927437641,
    ],
    free_bet_total_win: [
      13000,
      979.5918367346932,
    ],
    free_bet_ultra_win: [
      15000,
      1319.1836734693893,
    ],
    inside_buttons: [
      18000,
      210.43083900226733,
    ],
    main_ambient: [
      20000,
      62035.011337868484,
    ],
    mega_win: [
      84000,
      2944.580498866216,
    ],
    outside_buttons: [
      88000,
      187.2108843537461,
    ],
    reel_spin: [
      90000,
      1516.5532879818643,
    ],
    reel_stop_01: [
      93000,
      277.18820861677784,
    ],
    reel_stop_02: [
      95000,
      253.96825396825307,
    ],
    reel_stop_03: [
      97000,
      256.87074829932044,
    ],
    reel_stop_04: [
      99000,
      256.87074829932044,
    ],
    reel_stop_05: [
      101000,
      259.7732426303878,
    ],
    regular_win: [
      103000,
      767.709750566894,
    ],
    scatter_stop: [
      105000,
      872.1995464852625,
    ],
    tap_to_play: [
      107000,
      1171.1564625850315,
    ],
    ultra_win: [
      110000,
      3078.095238095244,
    ],
    wild_stop: [
      115000,
      811.2471655328761,
    ],
  },
}
